import { z } from 'zod'

export const RecuperaStatusSchema = z
  .object({
    is_active: z.boolean(),
    activated_at: z.string().nullable().optional(),
    active_product_count: z.number().optional(),
  })
  .passthrough()

export const RecuperaOptOutSchema = z
  .object({
    is_active: z.boolean(),
    deactivated_at: z.string().nullable().optional(),
  })
  .passthrough()

export const RecuperaCartItemSchema = z
  .object({
    order_id: z.string(),
    customer_name: z.string().nullable(),
    customer_email: z.string().nullable(),
    phone: z.string().nullable(),
    product_name: z.string().nullable(),
    product_price: z.string().nullable(),
    product_type: z.enum(['main', 'upsell']).nullable().optional(),
    paid_value: z.string().nullable(),
    abandoned_at: z.string(),
    recovered_at: z.string().nullable(),
    converted_at: z.string().nullable().optional(),
    recovery_type: z.enum(['recuperaai', 'external']).nullable().optional(),
    utm_medium: z.string().nullable(),
    currency: z.string().nullable().optional(),
  })
  .passthrough()

export const RecuperaCartsSchema = z.object({
  items: z.array(RecuperaCartItemSchema),
  next_cursor: z.string().nullable(),
})

export const RecuperaProductsSchema = z.object({
  items: z.array(z.string()),
})

export const RecuperaRecoveryProductSchema = z.object({
  id: z.string(),
  name: z.string(),
  selected: z.boolean(),
})

export const RecuperaRecoveryProductsSchema = z.object({
  items: z.array(RecuperaRecoveryProductSchema),
})

export const RecuperaChannelSchema = z.object({
  channel: z.string(),
  recovered_count: z.number(),
  recovered_revenue: z.string(),
})

export const RecuperaMetricsSchema = z.object({
  period: z.object({ from: z.string(), to: z.string() }),
  by_channel: z.array(RecuperaChannelSchema),
  total: z.object({
    recovered_count: z.number(),
    recovered_revenue: z.string(),
    abandoned_count: z.number(),
  }),
})

export type RecuperaStatus = z.infer<typeof RecuperaStatusSchema>
export type RecuperaOptOut = z.infer<typeof RecuperaOptOutSchema>
export type RecuperaCartItem = z.infer<typeof RecuperaCartItemSchema>
export type RecuperaCarts = z.infer<typeof RecuperaCartsSchema>
export type RecuperaChannel = z.infer<typeof RecuperaChannelSchema>
export type RecuperaMetrics = z.infer<typeof RecuperaMetricsSchema>
export type RecuperaProducts = z.infer<typeof RecuperaProductsSchema>
export type RecuperaRecoveryProduct = z.infer<typeof RecuperaRecoveryProductSchema>
export type RecuperaRecoveryProducts = z.infer<typeof RecuperaRecoveryProductsSchema>

export type RecuperaCartStatus = 'abandoned' | 'recovered' | 'external'

export type RecuperaCartSort = 'date_desc' | 'date_asc' | 'name_asc' | 'price_asc' | 'price_desc'
